import React, { useEffect, useState, useRef, useCallback } from 'react';
import AdminNav from '../components/AdminNav';

const s = {
  page: { minHeight: '100vh', background: '#f8f8f6' },
  nav: {
    background: '#111', color: '#fff', padding: '0 32px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    height: '56px',
  },
  content: { maxWidth: '1100px', margin: '0 auto', padding: '40px 16px' },
  heading: { fontSize: '22px', fontWeight: '700', color: '#111', marginBottom: '8px' },
  topRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' },
  btn: {
    padding: '10px 20px', background: '#111', color: '#fff',
    border: 'none', borderRadius: '8px', fontSize: '14px',
    fontWeight: '600', cursor: 'pointer',
  },
  table: { width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 1px 8px rgba(0,0,0,0.07)' },
  th: { padding: '12px 16px', textAlign: 'left', fontSize: '12px', fontWeight: '700', color: '#888', borderBottom: '1px solid #eee', background: '#fafafa', letterSpacing: '0.04em', textTransform: 'uppercase' },
  td: { padding: '12px 16px', fontSize: '14px', color: '#222', borderBottom: '1px solid #f0f0f0' },
  trHover: { cursor: 'pointer' },
  actionBtn: {
    padding: '5px 12px', borderRadius: '6px', border: 'none',
    fontSize: '12px', fontWeight: '600', cursor: 'pointer', marginRight: '6px',
  },
  // Batch modal
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000, padding: '16px',
  },
  modal: {
    background: '#fff', borderRadius: '12px',
    boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
    width: '75vw',
    maxHeight: '90vh', display: 'flex', flexDirection: 'column',
  },
  modalHeader: {
    padding: '20px 24px 16px', borderBottom: '1px solid #eee',
    display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
    flexShrink: 0,
  },
  modalTitle: { fontSize: '18px', fontWeight: '700', color: '#111' },
  modalMeta: { display: 'flex', gap: '20px', marginTop: '8px', flexWrap: 'wrap' },
  metaBadge: {
    fontSize: '13px', color: '#555', background: '#f4f4f4',
    borderRadius: '6px', padding: '3px 10px',
  },
  closeBtn: {
    background: '#f4f4f4', border: 'none', fontSize: '18px',
    cursor: 'pointer', color: '#444', lineHeight: 1,
    padding: '6px 10px', borderRadius: '6px', flexShrink: 0,
  },
  modalFilters: {
    padding: '12px 24px', borderBottom: '1px solid #eee',
    display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap',
    flexShrink: 0,
  },
  filterBtn: (active) => ({
    padding: '5px 14px', borderRadius: '20px', border: '1.5px solid',
    fontSize: '13px', fontWeight: '600', cursor: 'pointer',
    borderColor: active ? '#111' : '#ddd',
    background: active ? '#111' : '#fff',
    color: active ? '#fff' : '#555',
  }),
  searchInput: {
    flex: 1, minWidth: '140px', padding: '6px 12px',
    border: '1.5px solid #ddd', borderRadius: '20px',
    fontSize: '13px', outline: 'none', fontFamily: 'monospace',
    textTransform: 'uppercase',
  },
  modalBody: { overflowY: 'auto', flex: 1 },
  certTable: { width: '100%', borderCollapse: 'collapse' },
  certTh: { padding: '10px 16px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#888', borderBottom: '1px solid #eee', background: '#fafafa', letterSpacing: '0.04em', textTransform: 'uppercase', position: 'sticky', top: 0 },
  certTd: { padding: '10px 16px', fontSize: '13px', color: '#222', borderBottom: '1px solid #f5f5f5' },
  certTrHover: { cursor: 'pointer' },
  // Edit cert modal
  editOverlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1100, padding: '16px',
  },
  editModal: {
    background: '#fff', borderRadius: '12px',
    boxShadow: '0 8px 40px rgba(0,0,0,0.22)',
    width: '100%', maxWidth: '520px',
    maxHeight: '90vh', overflowY: 'auto',
    padding: '28px',
  },
  editModalTitle: { fontSize: '16px', fontWeight: '700', color: '#111', marginBottom: '20px' },
  fieldWrap: { marginBottom: '16px', position: 'relative' },
  label: { display: 'block', fontSize: '13px', fontWeight: '600', color: '#444', marginBottom: '6px' },
  input: { width: '100%', padding: '10px 12px', border: '1.5px solid #ddd', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' },
  textarea: { width: '100%', padding: '10px 12px', border: '1.5px solid #ddd', borderRadius: '8px', fontSize: '14px', outline: 'none', resize: 'vertical', minHeight: '72px', boxSizing: 'border-box' },
  dropdown: {
    position: 'absolute', top: '100%', left: 0, right: 0,
    background: '#fff', border: '1.5px solid #ddd', borderTop: 'none',
    borderRadius: '0 0 8px 8px', zIndex: 200,
    maxHeight: '160px', overflowY: 'auto',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  },
  dropdownItem: { padding: '9px 12px', cursor: 'pointer', fontSize: '14px' },
  editModalBtns: { display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' },
  cancelBtn: { padding: '9px 18px', background: '#fff', color: '#444', border: '1.5px solid #ddd', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' },
  saveBtn: { padding: '9px 18px', background: '#111', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' },
  editError: { color: '#dc2626', fontSize: '13px', marginTop: '8px' },
};

function AutocompleteField({ label, field, value, onChange, placeholder }) {
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const debounceRef = useRef(null);
  const wrapRef = useRef(null);

  const fetchSuggestions = useCallback((q) => {
    if (!q) { setSuggestions([]); return; }
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      try {
        const res = await fetch(
          `/api/admin/autocomplete/${field}?q=${encodeURIComponent(q)}`,
          { credentials: 'include' }
        );
        const data = await res.json();
        setSuggestions(Array.isArray(data) ? data : []);
        setOpen(true);
      } catch { /* ignore */ }
    }, 200);
  }, [field]);

  useEffect(() => {
    function handleClick(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div style={s.fieldWrap} ref={wrapRef}>
      <label style={s.label}>{label}</label>
      <input
        style={s.input}
        value={value}
        onChange={(e) => { onChange(e.target.value); fetchSuggestions(e.target.value); }}
        onFocus={() => { if (suggestions.length > 0) setOpen(true); }}
        placeholder={placeholder}
        autoComplete="off"
      />
      {open && suggestions.length > 0 && (
        <div style={s.dropdown}>
          {suggestions.map((sg) => (
            <div
              key={sg}
              style={s.dropdownItem}
              onMouseDown={() => { onChange(sg); setOpen(false); setSuggestions([]); }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#f5f5f5'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = ''; }}
            >
              {sg}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// Compact input for the bulk edit bar: autocomplete for fields that have
// suggestion data, a date picker for signedDate, plain text otherwise.
const AUTOCOMPLETE_FIELDS = ['signedBy', 'item', 'location'];

function BulkValueInput({ field, value, onChange, style }) {
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const debounceRef = useRef(null);
  const wrapRef = useRef(null);
  const canSuggest = AUTOCOMPLETE_FIELDS.includes(field);

  const fetchSuggestions = useCallback((q) => {
    if (!q || !canSuggest) { setSuggestions([]); return; }
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      try {
        const res = await fetch(
          `/api/admin/autocomplete/${field}?q=${encodeURIComponent(q)}`,
          { credentials: 'include' }
        );
        const data = await res.json();
        setSuggestions(Array.isArray(data) ? data : []);
        setOpen(true);
      } catch { /* ignore */ }
    }, 200);
  }, [field, canSuggest]);

  useEffect(() => {
    function handleClick(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  // Reset suggestions when switching fields
  useEffect(() => { setSuggestions([]); setOpen(false); }, [field]);

  return (
    <div style={{ position: 'relative', flex: 1, minWidth: '180px' }} ref={wrapRef}>
      <input
        type={field === 'signedDate' ? 'date' : 'text'}
        value={value}
        onChange={(e) => { onChange(e.target.value); fetchSuggestions(e.target.value); }}
        onFocus={() => { if (suggestions.length > 0) setOpen(true); }}
        placeholder={field === 'signedDate' ? 'YYYY-MM-DD' : 'New value (blank to clear)'}
        autoComplete="off"
        style={{ width: '100%', boxSizing: 'border-box', padding: '5px 10px', border: '1.5px solid #bfdbfe', borderRadius: '6px', fontSize: '13px', outline: 'none', ...style }}
      />
      {open && suggestions.length > 0 && (
        <div style={s.dropdown}>
          {suggestions.map((sg) => (
            <div
              key={sg}
              style={s.dropdownItem}
              onMouseDown={() => { onChange(sg); setOpen(false); setSuggestions([]); }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#f5f5f5'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = ''; }}
            >
              {sg}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const emptyEdit = { signedBy: '', signedDate: '', item: '', notes: '', location: '' };

export default function BatchManager() {
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [modal, setModal] = useState(null); // { batch }
  const [certs, setCerts] = useState([]);
  const [certsLoading, setCertsLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState('all');
  const [search, setSearch] = useState('');
  // Edit cert modal
  const [editModal, setEditModal] = useState(null); // cert object
  const [editForm, setEditForm] = useState(emptyEdit);
  const [editSaving, setEditSaving] = useState(false);
  const [editError, setEditError] = useState('');
  const [editPhotoFile, setEditPhotoFile] = useState(null);
  const [editPhotoPreview, setEditPhotoPreview] = useState(null);
  const [batchCount, setBatchCount] = useState(1);
  const [selectedBatches, setSelectedBatches] = useState(new Set());
  const [exporting, setExporting] = useState(false);
  const [lastGenerated, setLastGenerated] = useState(null); // [batchNum, ...]
  // Bulk cert edit
  const [certSelections, setCertSelections] = useState(new Set());
  const [bulkField, setBulkField] = useState('location');
  const [bulkValue, setBulkValue] = useState('');
  const [bulkPhotoFile, setBulkPhotoFile] = useState(null);
  const [bulkSaving, setBulkSaving] = useState(false);
  const lastCheckedRef = useRef(null);

  const role = localStorage.getItem('role');

  const fetchBatches = () => {
    setLoading(true);
    fetch('/api/admin/batches', { credentials: 'include' })
      .then((r) => r.json())
      .then((data) => setBatches(Array.isArray(data) ? data : []))
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(fetchBatches, []); // eslint-disable-line

  const fetchCerts = useCallback((batchNum, status, searchVal) => {
    setCertsLoading(true);
    const params = new URLSearchParams();
    if (status !== 'all') params.set('status', status);
    if (searchVal) params.set('search', searchVal);
    fetch(`/api/admin/batches/${batchNum}/certs?${params}`, { credentials: 'include' })
      .then((r) => r.json())
      .then((data) => setCerts(Array.isArray(data) ? data : []))
      .catch(console.error)
      .finally(() => setCertsLoading(false));
  }, []); // eslint-disable-line

  const openModal = (batch) => {
    setModal(batch);
    setStatusFilter('all');
    setSearch('');
    setCertSelections(new Set());
    setBulkValue('');
    setBulkPhotoFile(null);
    lastCheckedRef.current = null;
    fetchCerts(batch.batchNum, 'all', '');
  };

  const closeModal = () => { setModal(null); setCerts([]); setCertSelections(new Set()); lastCheckedRef.current = null; };

  // Close batch modal on Escape key
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') { closeEditModal(); closeModal(); } };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []); // eslint-disable-line

  useEffect(() => {
    if (!modal) return;
    fetchCerts(modal.batchNum, statusFilter, search);
  }, [statusFilter]); // eslint-disable-line

  const handleSearch = (val) => {
    setSearch(val);
    if (!modal) return;
    fetchCerts(modal.batchNum, statusFilter, val);
  };

  const openEditModal = (cert) => {
    setEditModal(cert);
    setEditForm({
      signedBy: cert.signedBy || '',
      signedDate: cert.signedDate ? cert.signedDate.slice(0, 10) : '',
      item: cert.item || '',
      notes: cert.notes || '',
      location: cert.location || '',
    });
    setEditError('');
  };

  const closeEditModal = () => { setEditModal(null); setEditError(''); setEditPhotoFile(null); setEditPhotoPreview(null); };

  const setEditField = (k) => (v) => setEditForm((f) => ({ ...f, [k]: v }));
  const setEditFieldE = (k) => (e) => setEditForm((f) => ({ ...f, [k]: e.target.value }));

  const saveEdit = async () => {
    setEditSaving(true);
    setEditError('');
    try {
      if (editPhotoFile) {
        const fd = new FormData();
        fd.append('photo', editPhotoFile);
        fd.append('certNums', JSON.stringify([editModal.certNum]));
        const photoRes = await fetch('/api/admin/certs/photo', { method: 'POST', credentials: 'include', body: fd });
        if (!photoRes.ok) {
          let msg = 'Photo upload failed.';
          try { const pd = await photoRes.json(); msg = pd.error || msg; } catch {}
          setEditError(msg);
          return;
        }
      }
      const res = await fetch(`/api/admin/certs/${editModal.certNum}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          signedBy: editForm.signedBy || null,
          signedDate: editForm.signedDate || null,
          item: editForm.item || null,
          notes: editForm.notes || null,
          location: editForm.location || null,
        }),
      });
      const data = await res.json();
      if (!res.ok) { setEditError(data.error || 'Save failed.'); return; }
      closeEditModal();
      if (modal) fetchCerts(modal.batchNum, statusFilter, search);
      fetchBatches();
    } catch {
      setEditError('Network error.');
    } finally {
      setEditSaving(false);
    }
  };

  const handleCertCheck = (e, index) => {
    const shiftKey = e.shiftKey;
    // Capture the anchor now — the setState updater runs after this handler
    // returns, by which point lastCheckedRef has already been overwritten.
    const anchor = lastCheckedRef.current;
    const certNum = certs[index].certNum;
    setCertSelections((prev) => {
      const next = new Set(prev);
      if (shiftKey && anchor !== null) {
        const lo = Math.min(anchor, index);
        const hi = Math.max(anchor, index);
        const adding = !prev.has(certNum);
        for (let i = lo; i <= hi; i++) {
          if (adding) next.add(certs[i].certNum);
          else next.delete(certs[i].certNum);
        }
      } else {
        if (next.has(certNum)) next.delete(certNum); else next.add(certNum);
      }
      return next;
    });
    lastCheckedRef.current = index;
  };

  const doBulkEdit = async () => {
    if (certSelections.size === 0) return;
    if (bulkField === 'photo' && !bulkPhotoFile &&
        !window.confirm(`Remove photos from ${certSelections.size} selected cert${certSelections.size > 1 ? 's' : ''}?`)) {
      return;
    }
    setBulkSaving(true);
    try {
      if (bulkField === 'photo' && bulkPhotoFile) {
        // Upload one photo and apply to every selected cert
        const fd = new FormData();
        fd.append('photo', bulkPhotoFile);
        fd.append('certNums', JSON.stringify([...certSelections]));
        const res = await fetch('/api/admin/certs/photo', { method: 'POST', credentials: 'include', body: fd });
        if (!res.ok) {
          let msg = 'Photo upload failed.';
          try { const d = await res.json(); msg = d.error || msg; } catch {}
          alert(msg);
          return;
        }
      } else {
        // Text fields, or photo with no file selected (= clear photos)
        const field = bulkField === 'photo' ? 'photoUrl' : bulkField;
        const value = bulkField === 'photo' ? null : (bulkValue || null);
        const res = await fetch('/api/admin/certs/bulk', {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ certNums: [...certSelections], field, value }),
        });
        const data = await res.json();
        if (!res.ok) { alert(data.error || 'Bulk update failed.'); return; }
      }
      setCertSelections(new Set());
      setBulkValue('');
      setBulkPhotoFile(null);
      if (modal) fetchCerts(modal.batchNum, statusFilter, search);
      fetchBatches();
    } catch {
      alert('Network error.');
    } finally {
      setBulkSaving(false);
    }
  };

  const exportBatchNums = async (nums) => {
    setExporting(true);
    try {
      const texts = await Promise.all(
        nums.map((bn) => fetch(`/api/admin/batches/${bn}/csv`, { credentials: 'include' }).then((r) => r.text()))
      );
      const lines = [];
      texts.forEach((csv, i) => {
        const rows = csv.trim().split('\n');
        if (i === 0) lines.push(...rows);
        else lines.push(...rows.slice(1));
      });
      const blob = new Blob([lines.join('\n')], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `batches-export-${Date.now()}.csv`;
      document.body.appendChild(a); a.click();
      document.body.removeChild(a); URL.revokeObjectURL(url);
    } catch {
      alert('Export failed.');
    } finally {
      setExporting(false);
    }
  };

  const generateBatch = async () => {
    const n = batchCount;
    if (!window.confirm(`Generate ${n} batch${n > 1 ? 'es' : ''}? Each creates ~1,150 certificate numbers.`)) return;
    setGenerating(true);
    setLastGenerated(null);
    try {
      const created = [];
      for (let i = 0; i < n; i++) {
        const res = await fetch('/api/admin/batches/generate', { method: 'POST', credentials: 'include' });
        const data = await res.json();
        if (!res.ok) { alert(data.error || 'Failed to generate batch.'); break; }
        created.push(data.batchNum);
      }
      if (created.length > 0) {
        setLastGenerated(created);
        fetchBatches();
      }
    } catch {
      alert('Network error.');
    } finally {
      setGenerating(false);
    }
  };

  const toggleSelect = (batchNum) => {
    setSelectedBatches((prev) => {
      const next = new Set(prev);
      if (next.has(batchNum)) next.delete(batchNum); else next.add(batchNum);
      return next;
    });
  };

  const toggleSelectAll = () => {
    setSelectedBatches(selectedBatches.size === batches.length ? new Set() : new Set(batches.map((b) => b.batchNum)));
  };

  const exportSelected = () => exportBatchNums([...selectedBatches]);

  const downloadCSV = (batchNum, e) => {
    e.stopPropagation();
    fetch(`/api/admin/batches/${batchNum}/csv`, { credentials: 'include' })
      .then((r) => r.blob())
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = `batch-${batchNum}.csv`;
        document.body.appendChild(a); a.click();
        document.body.removeChild(a); URL.revokeObjectURL(url);
      })
      .catch(() => alert('Download failed.'));
  };

  const deleteBatch = async (batchNum, e) => {
    e.stopPropagation();
    if (!window.confirm(`Delete batch ${batchNum} and ALL its certificates? This cannot be undone.`)) return;
    try {
      const res = await fetch(`/api/admin/batches/${batchNum}`, { method: 'DELETE', credentials: 'include' });
      const data = await res.json();
      if (!res.ok) return alert(data.error || 'Delete failed.');
      fetchBatches();
    } catch {
      alert('Network error.');
    }
  };

  const fmt = (d) => d ? new Date(d).toLocaleDateString() : '—';
  const fmtDate = (d) => {
    if (!d) return '—';
    const [y, m, day] = d.slice(0, 10).split('-').map(Number);
    return new Date(y, m - 1, day).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  return (
    <div style={s.page}>
      <AdminNav />

      <div style={s.content}>
        <div style={s.topRow}>
          <div style={s.heading}>Batch Manager</div>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            {selectedBatches.size > 0 && (
              <button onClick={exportSelected} style={{ ...s.btn, background: '#0369a1' }} disabled={exporting}>
                {exporting ? 'Exporting…' : `Export Selected (${selectedBatches.size})`}
              </button>
            )}
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ fontSize: '13px', color: '#666' }}>Count:</span>
              <input
                type="number" min={1} max={50} value={batchCount}
                onChange={(e) => setBatchCount(Math.min(50, Math.max(1, parseInt(e.target.value) || 1)))}
                style={{ width: '54px', padding: '8px', border: '1.5px solid #ddd', borderRadius: '8px', fontSize: '14px', textAlign: 'center', outline: 'none' }}
              />
            </div>
            <button onClick={generateBatch} style={s.btn} disabled={generating}>
              {generating ? 'Generating…' : '+ Generate Batch'}
            </button>
          </div>
        </div>

        {lastGenerated && (
          <div style={{
            background: '#f0fdf4', border: '1.5px solid #86efac', borderRadius: '8px',
            padding: '12px 16px', marginBottom: '20px',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap',
          }}>
            <span style={{ fontSize: '14px', color: '#14532d' }}>
              Generated <strong>{lastGenerated.length}</strong> batch{lastGenerated.length > 1 ? 'es' : ''}:{' '}
              <span style={{ fontFamily: 'monospace' }}>{lastGenerated.join(', ')}</span>
            </span>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                onClick={() => exportBatchNums(lastGenerated)}
                disabled={exporting}
                style={{ padding: '6px 14px', background: '#16a34a', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
              >
                {exporting ? 'Exporting…' : 'Export to CSV'}
              </button>
              <button
                onClick={() => setLastGenerated(null)}
                style={{ padding: '6px 12px', background: 'transparent', color: '#6b7280', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' }}
              >
                Dismiss
              </button>
            </div>
          </div>
        )}

        {loading ? (
          <p style={{ color: '#888' }}>Loading…</p>
        ) : batches.length === 0 ? (
          <p style={{ color: '#888' }}>No batches yet. Generate your first batch above.</p>
        ) : (
          <table style={s.table}>
            <thead>
              <tr>
                <th style={{ ...s.th, width: '40px' }}>
                  <input type="checkbox" checked={selectedBatches.size === batches.length} onChange={toggleSelectAll} />
                </th>
                {['Batch #', 'Created', 'Total Certs', 'Assigned', 'Unassigned', 'Actions'].map((h) => (
                  <th key={h} style={s.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {batches.map((b) => (
                <tr key={b.batchNum} style={s.trHover} onClick={() => openModal(b)}>
                  <td style={s.td} onClick={(e) => e.stopPropagation()}>
                    <input type="checkbox" checked={selectedBatches.has(b.batchNum)} onChange={() => toggleSelect(b.batchNum)} />
                  </td>
                  <td style={{ ...s.td, fontFamily: 'monospace', fontWeight: '700', fontSize: '15px' }}>{b.batchNum}</td>
                  <td style={s.td}>{fmt(b.dateCreated)}</td>
                  <td style={s.td}>{b.totalCerts?.toLocaleString()}</td>
                  <td style={s.td}>{b.assignedCount?.toLocaleString()}</td>
                  <td style={s.td}>{b.unassignedCount?.toLocaleString()}</td>
                  <td style={s.td} onClick={(e) => e.stopPropagation()}>
                    <button
                      style={{ ...s.actionBtn, background: '#f0f9ff', color: '#0369a1' }}
                      onClick={(e) => downloadCSV(b.batchNum, e)}
                    >
                      CSV
                    </button>
                    {role === 'dev' && (
                      <button
                        style={{ ...s.actionBtn, background: '#fef2f2', color: '#dc2626' }}
                        onClick={(e) => deleteBatch(b.batchNum, e)}
                      >
                        Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Batch detail modal */}
      {modal && (
        <div style={s.overlay} onClick={closeModal}>
          <div style={s.modal} onClick={(e) => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <div>
                <div style={s.modalTitle}>Batch <span style={{ fontFamily: 'monospace' }}>{modal.batchNum}</span></div>
                <div style={s.modalMeta}>
                  <span style={s.metaBadge}>Created {fmt(modal.dateCreated)}</span>
                  <span style={s.metaBadge}>{modal.totalCerts?.toLocaleString()} total</span>
                  <span style={{ ...s.metaBadge, background: '#f0fdf4', color: '#15803d' }}>{modal.assignedCount?.toLocaleString()} assigned</span>
                  <span style={{ ...s.metaBadge, background: '#fefce8', color: '#854d0e' }}>{modal.unassignedCount?.toLocaleString()} unassigned</span>
                </div>
              </div>
              <button style={s.closeBtn} onClick={closeModal}>×</button>
            </div>

            <div style={s.modalFilters}>
              {['all', 'assigned', 'unassigned'].map((f) => (
                <button key={f} style={s.filterBtn(statusFilter === f)} onClick={() => setStatusFilter(f)}>
                  {f.charAt(0).toUpperCase() + f.slice(1)}
                </button>
              ))}
              <input
                style={s.searchInput}
                placeholder="Search cert #"
                value={search}
                onChange={(e) => handleSearch(e.target.value.toUpperCase())}
                maxLength={6}
                spellCheck={false}
              />
              <span style={{ fontSize: '13px', color: '#888', marginLeft: 'auto' }}>
                {certsLoading ? 'Loading…' : `${certs.length} certs`}
              </span>
            </div>

            {certSelections.size > 0 && (
              <div style={{ padding: '10px 24px', borderBottom: '1px solid #eee', background: '#eff6ff', display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', flexShrink: 0 }}>
                <span style={{ fontSize: '13px', fontWeight: '600', color: '#1d4ed8' }}>{certSelections.size} selected</span>
                <select
                  value={bulkField}
                  onChange={(e) => { setBulkField(e.target.value); setBulkValue(''); setBulkPhotoFile(null); }}
                  style={{ padding: '5px 8px', border: '1.5px solid #bfdbfe', borderRadius: '6px', fontSize: '13px', background: '#fff', outline: 'none' }}
                >
                  {[['signedBy','Signed By'],['signedDate','Signed Date'],['item','Item'],['notes','Notes'],['location','Location'],['photo','Photo']].map(([v, l]) => (
                    <option key={v} value={v}>{l}</option>
                  ))}
                </select>
                {bulkField === 'photo' ? (
                  <div style={{ flex: 1, minWidth: '180px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="file"
                      accept="image/jpeg,image/png,image/webp"
                      style={{ fontSize: '12px', color: '#444' }}
                      onChange={(e) => setBulkPhotoFile(e.target.files[0] || null)}
                    />
                    {!bulkPhotoFile && (
                      <span style={{ fontSize: '12px', color: '#6b7280' }}>no file = remove photos</span>
                    )}
                  </div>
                ) : (
                  <BulkValueInput field={bulkField} value={bulkValue} onChange={setBulkValue} />
                )}
                <button
                  onClick={doBulkEdit}
                  disabled={bulkSaving}
                  style={{ padding: '5px 14px', background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
                >
                  {bulkSaving ? 'Saving…' : 'Apply'}
                </button>
                <button
                  onClick={() => setCertSelections(new Set())}
                  style={{ padding: '5px 12px', background: 'transparent', color: '#6b7280', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' }}
                >
                  Clear
                </button>
              </div>
            )}

            <div style={s.modalBody}>
              {certsLoading ? (
                <div style={{ padding: '32px', textAlign: 'center', color: '#888', fontSize: '14px' }}>Loading…</div>
              ) : certs.length === 0 ? (
                <div style={{ padding: '32px', textAlign: 'center', color: '#888', fontSize: '14px' }}>No certificates match.</div>
              ) : (
                <table style={s.certTable}>
                  <thead>
                    <tr>
                      <th style={{ ...s.certTh, width: '36px' }}>
                        <input
                          type="checkbox"
                          checked={certs.length > 0 && certSelections.size === certs.length}
                          onChange={() => setCertSelections(
                            certSelections.size === certs.length ? new Set() : new Set(certs.map((c) => c.certNum))
                          )}
                        />
                      </th>
                      {['Cert #', 'Status', 'Photo', 'Signed By', 'Item', 'Location', 'Signed Date'].map((h) => (
                        <th key={h} style={s.certTh}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {certs.map((c, i) => (
                      <tr
                        key={c.certNum}
                        style={s.certTrHover}
                        onClick={() => openEditModal(c)}
                        onMouseEnter={(e) => { e.currentTarget.style.background = '#f9f9f9'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = ''; }}
                      >
                        <td style={s.certTd} onClick={(e) => e.stopPropagation()}>
                          <input
                            type="checkbox"
                            checked={certSelections.has(c.certNum)}
                            onChange={() => {}}
                            onClick={(e) => handleCertCheck(e, i)}
                          />
                        </td>
                        <td style={{ ...s.certTd, fontFamily: 'monospace', fontWeight: '700' }}>{c.certNum}</td>
                        <td style={s.certTd}>
                          <span style={{
                            padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: '700',
                            background: c.signedBy ? '#f0fdf4' : '#fefce8',
                            color: c.signedBy ? '#15803d' : '#854d0e',
                          }}>
                            {c.signedBy ? 'Assigned' : 'Unassigned'}
                          </span>
                        </td>
                        <td style={s.certTd}>
                          {c.photoUrl
                            ? <span style={{ padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: '700', background: '#eff6ff', color: '#1d4ed8' }}>Yes</span>
                            : <span style={{ color: '#ccc', fontSize: '13px' }}>—</span>
                          }
                        </td>
                        <td style={s.certTd}>{c.signedBy || '—'}</td>
                        <td style={s.certTd}>{c.item || '—'}</td>
                        <td style={s.certTd}>{c.location || '—'}</td>
                        <td style={s.certTd}>{fmtDate(c.signedDate)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Edit cert modal */}
      {editModal && (
        <div style={s.editOverlay} onClick={closeEditModal}>
          <div style={s.editModal} onClick={(e) => e.stopPropagation()}>
            <div style={s.editModalTitle}>
              Edit Certificate — <span style={{ fontFamily: 'monospace' }}>{editModal.certNum}</span>
            </div>

            <AutocompleteField
              label="Signed By"
              field="signedBy"
              value={editForm.signedBy}
              onChange={setEditField('signedBy')}
              placeholder="Name of signer"
            />

            <div style={s.fieldWrap}>
              <label style={s.label}>Signed Date</label>
              <input style={s.input} type="date" value={editForm.signedDate} onChange={setEditFieldE('signedDate')} />
            </div>

            <AutocompleteField
              label="Item"
              field="item"
              value={editForm.item}
              onChange={setEditField('item')}
              placeholder="e.g. Baseball, Helmet, Photo 8x10"
            />

            <div style={s.fieldWrap}>
              <label style={s.label}>Notes</label>
              <textarea style={s.textarea} value={editForm.notes} onChange={setEditFieldE('notes')} placeholder="Optional notes…" />
            </div>

            <AutocompleteField
              label="Location"
              field="location"
              value={editForm.location}
              onChange={setEditField('location')}
              placeholder="e.g. New York, NY"
            />

            <div style={s.fieldWrap}>
              <label style={s.label}>Photo</label>
              {(editPhotoPreview || editModal?.photoUrl) && (
                <img
                  src={editPhotoPreview || editModal.photoUrl}
                  alt="Certificate item"
                  style={{ display: 'block', maxWidth: '100%', maxHeight: '180px', borderRadius: '6px', border: '1px solid #eee', marginBottom: '8px', objectFit: 'cover' }}
                />
              )}
              <input
                type="file"
                accept="image/jpeg,image/png,image/webp"
                style={{ fontSize: '13px', color: '#666' }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) { setEditPhotoFile(file); setEditPhotoPreview(URL.createObjectURL(file)); }
                }}
              />
            </div>

            {editError && <div style={s.editError}>{editError}</div>}

            <div style={s.editModalBtns}>
              <button style={s.cancelBtn} onClick={closeEditModal}>Cancel</button>
              <button style={s.saveBtn} onClick={saveEdit} disabled={editSaving}>
                {editSaving ? 'Saving…' : 'Save Changes'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
